<template>
    <div class="bee_invite_mobile_layout">

        <div class="mobile_header_bar">
            <div class="icon_back" @click="doClose" />
            <div class="mobile_title">Friends</div>
            <div class="icon_back" style=" visibility: hidden;" />
        </div>





        <div class="scroll_layout">

            <div class="mobile_top_layout">

                <div>
                    <div class="mobile_txt_info_layout">

                        <div class="mobile_invite_info_layout">

                            <div class="invite_title_txt">Bring pal, earn more!</div>

                            <div class="info_line"></div>

                            <div class="mobile_invite_info">For each new friend, you'll receive <span
                                    class="red_xp_num">{{
                                        normalOnceRewardAmount
                                    }}xp</span> plus <span class="red_xp_num">{{ dividendYield }}%</span> of all their
                                XP
                                earnings


                            </div>


                        </div>
                        <div style="flex: 1;;width:45%">
                        </div>

                        <div style=" position: sticky;z-index: 1;right:0;display: flex; align-items: end;">

                            <div class="img_ipx" />
                        </div>

                    </div>
                </div>
            </div>

            <div class="invite_info_layout">


                <div class="rf_info_title">Invite friends to get bonus</div>

                <div class="xp_info_layout">

                    <div class="item_for_xp">
                        <div class="ic_logo"></div>
                        <div class="for_txt">For you</div>
                        <div class="for_xp_txt">
                            {{ normalOnceRewardAmount }}
                        </div>

                    </div>

                    <div class="item_for_xp">
                        <div class="ic_logo"></div>
                        <div class="for_txt">For your friend</div>
                        <div class="for_xp_txt">
                            {{ superOnceReferralAmount }}
                        </div>

                    </div>

                </div>

            </div>




            <div class="rf_btn_layout">
                <div class="btn_invite_layout" @click="showShareDialog">

                    <div class="rf_share_div"></div>

                    <div class="rf_share_text">Invite a Friend</div>


                </div>
                <div class="btn_copy_layout">
                    <div class="mobile_icon_copy" @click="copyToPCClipboard()"></div>
                </div>
            </div>


            <div class="invite_info_layout" style="margin-top: 14px;margin-bottom: 100px;">


                <div class="rf_friend_layout">
                    <div class="friend_all_layout">
                        <div class="">Friends List ({{ friendsAmount }}) </div>
                    </div>
                    <div>
                        <div v-if="isClaim" class="submit_load">
                            <div class="loading_logo"></div>
                        </div>

                        <div v-else :class="xpCanClaimAmount != 0 ? 'submit_get' : 'submit_get_un'" @click="claim">
                            Claim all
                        </div>

                    </div>
                </div>

                <div class="rf_friend_layout">
                    <div class="friend_all_layout">

                    </div>
                    <div>
                        <div style="display:flex;flex-direction: row; margin-top: 6px;align-items: center">
                            <div class="total_txt">Total amount:</div>
                            <div class="mini_ic_logo"></div>

                            <div class="total_num">{{ xpCanClaimAmount }}</div>
                        </div>



                    </div>
                </div>


                <div class="mobile_line"></div>


                <UserListView :listData="listData"></UserListView>

            </div>

        </div>




    </div>




</template>

<script>

import Toast from "../message.js";
import { AccountStore } from "../../util/Account.js";
import { InviteInfoStore } from "../../util/InviteInfo.js";
import UserListView from "../view/UserListView.vue"
import inviteBtn from "../view/inviteBtn.vue"
import pcLayout from "./pcHome.vue"

import shareDialog from "./shareDialog.vue"

import { base_url } from '../../util/mock.js'


export default {
    name: 'mobileView',
    emits: ["claim", "share"],
    components: {
        UserListView,
        inviteBtn,
        pcLayout,
        shareDialog
    },

    props: {
        inviteUrl: '',
        inviteDispayUrl: "",
        normalOnceRewardAmount: 0,
        superOnceReferralAmount: 0,
        friendsAmount: 0,
        dividendYield: 0,
        xpCanClaimAmount: 0,
        inviteCode: "",
        listData: []
    },

    data() {
        return {
            loginUrl: "",
            isUserLoginStatus: false,
            inviteData: '',
            // xpCanClaimAmount: 100,
            // inviteCode: "",
            // listData: [
            // {
            //     "userId": "testp000@qq.com",
            //     "name": "testp000",
            //     "avatar": "",
            //     "dividendXp": 2600.000000000018
            // },
            // {
            //     "userId": "kiko@nqmo.com",
            //     "name": "kiko",
            //     "avatar": "",
            //     "dividendXp": 2523.2000000000007
            // }
            // ],
            // inviteUrl: '',
            // inviteDispayUrl: "",
            // normalOnceRewardAmount: 0,
            // superOnceReferralAmount: 0,
            // friendsAmount: 0,
            // dividendYield: 0,
            // xpCanClaimAmount: 0,

            isClaim: false,
        }
    },

    watch: {
    },

    methods: {

        doClose() {
            let view = document.getElementById("bee_nInvite");
            view.style.display = "none";
        },

        getQueryString(url) {
            let ItemArr = [];
            let ItemObj = {};
            url
                .substring(url.lastIndexOf("?") + 1, url.length)
                .split("&")
                .map((item) => {
                    ItemArr.push(item.split("="));
                });
            ItemArr.map((item) => {
                ItemObj[item[0]] = item[1];
            });
            return ItemObj;
        },


        // async getUserLoginInfo() {
        //     await AccountStore.fetchUserInfo();
        //     this.isUserLoginStatus = AccountStore.isUserLoginStatus;
        //     if (this.isUserLoginStatus) {
        //         await InviteInfoStore.fetchInviteInfo();

        //         console.log(InviteInfoStore.iInviteInfo);
        //         this.inviteData = InviteInfoStore.iInviteInfo;
        //         this.inviteCode = this.inviteData.referralCode;
        //         this.inviteUrl = base_url() + "?bCode=" + this.inviteCode;
        //         this.inviteDispayUrl = "http://w" + "..." + "?bCode=" + this.inviteCode;
        //         this.dividendYield = this.inviteData.dividendYield * 100;
        //         this.xpCanClaimAmount = this.inviteData.xpCanClaimAmount;
        //         this.normalOnceRewardAmount = this.inviteData.normalOnceRewardAmount;
        //         this.superOnceReferralAmount = this.inviteData.superOnceReferralAmount;
        //         this.friendsAmount = this.inviteData.friendsAmount;

        //         this.listData = InviteInfoStore.friends;

        //     } else {

        //     }

        // },

        goInvite() {
            let url = base_url() + "?bCode=" + this.inviteCode;
            window.location.href = url;
        },

        async claim() {
            if (this.xpCanClaimAmount == 0) {
                return;
            }
            this.isClaim = true;
            let rDate = await InviteInfoStore.referralClaim();
            this.$emit("claim", 0);
            // this.getUserLoginInfo();
            this.isClaim = false;
        },
        showShareDialog() {
            this.$emit("share", 0);
            // this.$refs.shareDialog.showDialog();
            // this.share();
        },

        copyToPCClipboard() {
            console.log("copyToClipboard")
            let copyText = "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!" + "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!" + " " + this.inviteUrl;

            navigator.clipboard.writeText(copyText).then(() => {
                Toast("Copy successful", "success")
            });

        },

        copyToClipboard(copyText) {

            navigator.clipboard.writeText(copyText).then(() => {
                Toast("Copy successful", "success")
            });

        },

        share() {
            if (navigator.share) {
                navigator.share({
                    title: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!",
                    text: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
                    url: this.inviteUrl
                }).then(() => {
                    console.log('Successful share');
                }).catch(error => {
                    console.log('Error sharing:', error);
                });
            } else {
                console.log('Web Share API is not supported.');
                this.showBeeShare();
            }
        },


        showBeeShare() {
            let shareContent = {
                share: this.inviteUrl,
                title: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!",
                content: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
            };
            // console.log(shareTxt + '');
            try {
                if (window.flutter_inappwebview) {
                    //
                    window.flutter_inappwebview.callHandler('sharePic', JSON.stringify(shareContent));
                } else {
                    window.flutter_inappwebview._callHandler('sharePic', JSON.stringify(shareContent));
                }
            } catch (e) {
                //TODO handle the exception


                navigator.clipboard.writeText(this.inviteUrl).then(() => {
                    Toast("Copy successful", "success")
                });
            }
        }


    },

    mounted() {
        // this.getUserLoginInfo();
    },


}

</script>

<style scoped>
.bee_invite_mobile_layout {
    flex-direction: column;
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
    height: 100%;
}

.mobile_title {
    color: #000;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    /* 155.556% */
}

.mobile_header_bar {
    display: flex;
    flex-direction: row;
    height: 56px;
    margin-top: 16px;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    justify-content: space-between;
}

.mobile_top_layout {}

.mobile_invite_info_layout {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    margin-right: 16px;
    min-width: 207px;
    padding: 12px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/ic_rf_txt_bg.png");
    /* border-top-right-radius: 12px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px; */
    margin-top: 12px;
    margin-bottom: 12px;
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.mobile_txt_info_layout {
    display: flex;
    flex-direction: row;
}

.invite_title_txt {
    color: #5D2E21;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    /* 112.5% */
}

.info_line {
    height: 2px;
    flex-shrink: 0;
    background-image: url("../../assets/txt_line.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 6px;
}

.mobile_invite_info {
    color: #5D2E21;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
}

.invite_info_layout {
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
    flex-direction: column;
    margin-left: 12px;
    margin-right: 12px;
    padding: 12px;
    border-radius: 12px;
    border: 1.5px solid #FFF;
    background: linear-gradient(180deg, #FFF3E3 8.66%, #FFF 41.73%);
}

.rf_info_title {
    display: flex;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: left;
}

.for_txt {
    color: #666;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.btn_invite_layout {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: #FFAB13;
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;
}

.btn_copy_layout {
    border-radius: 12px;
    background: #FFAB13;
    width: 64px;
    height: 48px;
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 12px;
}

.rf_btn_layout {
    display: flex;
    margin-top: 14px;
    margin-left: 12px;
    margin-right: 12px;
    flex-direction: row;
}

.rf_share_div {
    width: 20px;
    height: 20px;
    background-image: url("../../assets/rf_friend.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.rf_share_text {
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}






.reward_content_radius {
    width: 76px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    flex-direction: column;
    background-color: #F29100;
    margin-left: -4px;
    border-radius: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
    border: 1px solid #fff;
}

.reward_content {
    width: 68px;
    height: 63px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.6;
    /* animation: rotate 10s linear infinite; */
}

@keyframes rotate {
    0% {
        transform: rotateY(0);
    }

    100% {
        transform: rotateY(720deg);
    }
}

.mobile_line {
    height: 0.5px;
    background-color: #EFEDEB;
    margin-top: 5px;
    margin-bottom: 4px;
    display: flex;
    stroke-width: 1px;
    margin-left: 0;
    margin-right: 0;
}

.bee_experience_logo {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-left: 2px;
}


.icon_back {
    width: 20px;
    height: 20px;
    background-image: url("../../assets/icon_dialog_close.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    cursor: pointer;
}

.reward_xp_layout {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}

.reward_text {
    font-size: 10px;
    color: #00c170;
    height: 16px;
    border-radius: 30px;
    background: #c6ffe7;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding-left: 18px;
    padding-right: 18px;
    margin-bottom: 2px;
    margin-top: 2px;
}

.mint_txt {
    color: #fff;
    font-size: 16px;
    width: 40px;
    text-align: center;
}





.xp_login {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: #fff;
}

.task_send {
    cursor: pointer;
    border-radius: 30px;
    background: #FFAE00;
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 166.667% */
    letter-spacing: 0.12px;
    padding-top: 4px;
    padding-bottom: 4px;
    width: 80px;
}


.xp_info_layout {
    display: flex;
    justify-content: space-between;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 12px;
    padding: 8px;
    padding-left: 40px;
    padding-right: 40px;
    align-items: center;
    flex-direction: row;
}

.ic_logo {
    width: 32px;
    height: 32px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/ic_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.mini_ic_logo {
    width: 12px;
    height: 12px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/ic_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-left: 1px;
    margin-right: 1px;
}

.for_xp_txt {
    color: #FFAB13;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.item_for_xp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}













.img_ipx {
    width: 166px;
    height: 163px;
    margin-right: 16px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/mobile_phone_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}






.mobile_icon_copy {
    width: 20px;
    height: 20px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/ic_copy.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    cursor: pointer;
}

.line {
    display: flex;
    height: 1px;
    stroke-width: 1px;
    stroke: rgba(240, 238, 238, 0.93);
    background-color: rgba(240, 238, 238, 0.93);
    margin-left: 12px;
    margin-right: 12px;
    width: -webkit-fill-available;
    width: -moz-available;
}

.scroll_layout {
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
}




.mobile_layout {
    display: none;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    height: 110%;
    background-color: #fff;
    overflow: auto;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/rf_bg.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.rf_friend_layout {
    display: flex;
    flex-direction: row;
}

.friend_all_layout {
    flex: 1;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.submit_load {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    border-radius: 8px;
    background: #FFE7B3;
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    width: 60px;
    display: flex;
}

.loading_logo {
    width: 18px;
    height: 18px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/loading.gif");
    background-size: cover;
    background-repeat: no-repeat;
    /* animation: rotate 2s linear infinite; */
}

.submit_get {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    border-radius: 8px;
    background: #FFAB13;
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}


.submit_get_un {
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    border-radius: 8px;
    background: rgba(255, 191, 108, 0.50);
    color: #fff;
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.total_txt {
    color: #999;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.total_num {
    color: #333;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.red_xp_num {
    color: #F53019;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 900;
    line-height: 20px;
}
</style>